import React, {Component, createRef, forwardRef} from 'react';
import FJDropDown from "fj-components/FJDropDown"
import FJSlider from '../../../../common/component/slider/FJSlider';
import FJVolumeIcon from '../../../../icon/volume.svg';
import FJMuteIcon from '../../../../icon/mute.svg';
import './FJPreviewVolumeContainer.less';
import InlineSVG from "react-inlinesvg"

const ForwardTrigger = forwardRef((props, ref) => {
  let {mute} = props;
   return (
     <div ref={ref} className='u-button-cursor c-modal-preview-ctr__btn c-modal-preview-ctr__btn-volume'>
       {mute ? <InlineSVG src={FJMuteIcon} element='div'/> :
         <InlineSVG src={FJVolumeIcon} element='div'/>}
     </div>
   );
});

class FJPreviewVolumeContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mute: false,
    };
    this.slider = createRef();
    this.dropdown = createRef();
  }

  componentDidMount() {
    this.resetVolume();
  }

  hideVolume = () => {
    this.dropdown.current.hide();
  };

  resetVolume = () => {
    this.slider.current.setProgress(1);
    this.setState({mute: false});
  };

  getVolume = () => {
    return this.slider.current.getProgress();
  };

  _sliderDataChange = (value, progress) => {
    this.props.previewVolumeChang(progress);
    this._updateVolumeIcon(this.state.mute);
  };

  _updateVolumeIcon = (preMute) => {
    let mute = this.slider.current.getProgress() === 0;
    if (mute !== preMute) {
      this.setState({mute: mute});
    }
  };

  render() {
    return (
      <FJDropDown overlay={
        <div className='c-preview-volume-popup-panel'>
          <div className='c-slider-container'>
            <FJSlider onChange={this._sliderDataChange}
                      vertical
                      useNative
                      ref={this.slider}/>
          </div>
        </div>
      }
                  placement='topCenter'
                  propsTop={20}
                  ref={this.dropdown}
                  overlayClassName='c-preview-volume-overlay' isTopLayer>
        <ForwardTrigger mute={this.state.mute} />
      </FJDropDown>
    );
  }
}

export default FJPreviewVolumeContainer;
